"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketsV2 = exports.PollingV2 = void 0;
const polling_1 = require("./polling");
Object.defineProperty(exports, "PollingV2", { enumerable: true, get: function () { return polling_1.Polling; } });
const websockets_1 = require("./websockets");
Object.defineProperty(exports, "WebSocketsV2", { enumerable: true, get: function () { return websockets_1.WebSockets; } });
__exportStar(require("./asyncConnection"), exports);
//# sourceMappingURL=index.js.map